import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { LoaderContext } from "../../../Services/Loader_Provider_Service/LoadingContext";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { AddModuleLesson, getOnlineTraining } from "./Services/SelfLearning";
import { Dropdown } from "primereact/dropdown";
import { useFormik } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import { TostMsg } from "../../../App";
import { LazyVideo } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import {
  GetMasterTypeData,
  uploadDoc,
} from "../../../Services/Global-Services/GlobalServices";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

function AddVideoContent() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "");
  const [courses, setCourses] = useState([]);
  const { showLoading, hideLoading } = useContext(LoaderContext);
  const { CourseId } = useParams();
  const { ModuleId } = useParams();
  const toster = useContext(TostMsg);

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videoURL, setVideoURL] = useState("");
  const [videoPath, setVideoPath] = useState([]);
  const [file, setFile] = useState(null);
    const [selectedLang, setSelectedLang] = useState([]);
    const [selectedLanguage, satLang] = React.useState('');
    const [selectedLevel, setSelectedLevel] = useState([]);
  useEffect(() => {
    GetOnlineTraining();
    getLanguage();
  }, []);
  async function GetOnlineTraining() {
    showLoading();
    let body = {
      AccountId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      UserId: 0,
      CourseId: Number(CourseId),
      Search: "",
      PageNumber: 1,
      CategoryId: 0,
      PageSize: 100,
      NewOnly: 0,
      BookmarkedOnly: 0,
      FreeOnly: 0,
      MyCourse: 0,
    };
    try {
      let response = await getOnlineTraining(body);
      hideLoading();
      setCourses(response.Data.courses[0]);
    } catch (err) {
      hideLoading();
    }
  }

    const getLanguage = async () => {
          let params1 = {
              masterType: 'LanguageType',
              allRecords: true,
              organisationId: userDetails?.OrgId
          }
           let params2 = {
              masterType : 'LevelType',
              allRecords: true,
              organisationId: userDetails?.OrgId
          }
          try {
              let responce = await GetMasterTypeData(params1);
              setSelectedLang(responce?.Data);
            //   let setLang = responce?.Data?.filter((el) => el?.Name == SelectedLang);
            //   satLang(setLang[0]);
          } catch (error) {
              toster.current.error(ERROR_LIST?.MasterDataType)
          }
          try {
              let responce = await GetMasterTypeData(params2);
              setSelectedLevel(responce?.Data);
            //   let setLang = responce?.Data?.filter((el) => el?.Name == SelectedLang);
            //   satLang(setLang[0]);
          } catch (error) {
              toster.current.error(ERROR_LIST?.MasterDataType)
          }
      }

  const AddLessonSchema = Yup.object().shape({
    Title: Yup.string().required("Title is required."),
    Language: Yup.string().required("Language is required."),
    Level: Yup.string().required("Level is required."),
    Duration: Yup.string().required("Duration is required."),
    Description: Yup.string().required("Description is required."),
    VideoURL: Yup.mixed()
      .required("Video is required.")
      .test("fileFormat", "Only mp4 are allowed", (value) => {
        if (value) {
          const supportedFormats = ["mp4"];
          return supportedFormats.includes(value.split(".").pop());
        }
        return true;
      }),
  });
  const LessonFrom = useFormik({
    initialValues: {
      Title: "",
      Language: "",
      Level: "",
      VideoURL: "",
      Duration: "",
      Description: "",
    },
    validationSchema: AddLessonSchema,
    onSubmit: async (data) => {
      showLoading();
      if (ModuleId) {
        const body = {
          Id: 0,
          GUID: userDetails.GUID,
          IsActive: true,
          CreatedDate: "2024-07-31T13:08:28.673Z",
          ModifiedDate: "2024-07-31T13:08:28.673Z",
          CreatedBy: Number(userDetails?.EmpId),
          ModifiedBy: Number(userDetails?.EmpId),
          OrgId: Number(userDetails?.OrgId),
          AccountId: Number(userDetails?.OrgId),
          CourseId: Number(CourseId),
          ModuleId: Number(ModuleId),
          Title: data.Title,
          VideoURL: data.VideoURL,
          Duration: String(data.Duration),
          Description: data.Description,
          IsViewed: true,
        };
        try {
          await AddModuleLesson(body);
          hideLoading();
          $("#award-popup").hide();
          GetOnlineTraining();
        } catch (err) {
          hideLoading();
      toster.current.error(ERROR_LIST.DefaultError);
        }
      } else {
        hideLoading();
      }
    },
  });

  const handleVideoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedVideo(file);
      setVideoURL(URL.createObjectURL(file));
    }
  };

  const fileInputVideoRef = useRef(null);
  function openFileVideoInput() {
    fileInputVideoRef.current.click();
  }
  const handleVideoFileChange = useCallback(async (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  }, []);

  useEffect(() => {
    if (file) {
      uploadPolicyDocFile();
    }
  }, [file]);
  // Upload your image and video data
  async function uploadPolicyDocFile() {
    showLoading();
    if (file) {
      const formData = new FormData();
      formData.append("files", file);
      try {
        const response = await uploadDoc(formData);
        const data = await response;
        hideLoading();
        const ImageURL = data?.Data[0];
        $(".upload-img").hide("slow");
        $(".input-Btn").show("slow");
        hideLoading();
        setVideoPath(ImageURL);
        LessonFrom.setFieldValue("VideoURL", ImageURL);
        setFile(null);
      } catch (error) {
        setFile(null);
        hideLoading();
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
        setFile(null);
        hideLoading();
      }
    } else {
      hideLoading();
      setFile(null);
      toster.current.warn("No file selected.");
    }
  }

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="col-md-9 shrink-w">
          <div className="form-head d-flex flex-wrap align-items-center mb-3">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Add Lesson</h2>
              <p className="text-light">Lorem ipsum dolor sit amet</p>
            </div>
            <div className="rightside-tabs">
              <Link to="CourseDetail">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="currentColor"
                  className="bi bi-arrow-left-short"
                  viewBox="0 0
 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 8a.5.5 0 0 1-.5.5H5.7
 07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
 .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                  ></path>
                </svg>
              </Link>
            </div>
          </div>
          <form onSubmit={LessonFrom.handleSubmit}>
            <div className="row">
              <div className="col-xl-8">
                <div className="col-xl-12">
                  <div className="supp-req">
                    <div className="addcourseform">
                      <div className="row">
                        <div className="mb-4 col-md-12">
                          <input
                            type="text"
                            cols="1"
                            rows="4"
                            name="Title"
                            value={LessonFrom.values.Title}
                            onChange={LessonFrom.handleChange}
                            className={
                              "form-control bg-chng" +
                              (LessonFrom.errors.Title &&
                              LessonFrom.touched.Title
                                ? "is-invalid"
                                : "")
                            }
                            placeholder="Your Lesson title goes here..|"
                          />
                        </div>
                        <div className="invalid-feedback">
                          {LessonFrom.errors.Title && LessonFrom.touched.Title
                            ? LessonFrom.errors.Title
                            : null}
                        </div>
                      </div>
                      <div className="row">
                        <div className="mb-4 col-md-4">
                          <label className="form-label">Language</label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-user-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <Dropdown
                              value={LessonFrom.values.Language}
                              onChange={(e) =>
                                LessonFrom.setFieldValue("Language", e.value.id)
                              }
                              options={selectedLang}
                              optionLabel="Name"
                              placeholder="Language"
                              checkmark={true}
                              highlightOnSelect={false}
                            />{" "}
                          </div>
                          <div className="invalid-feedback">
                            {LessonFrom.errors.Title && LessonFrom.touched.Title
                              ? LessonFrom.errors.Title
                              : null}
                          </div>
                        </div>
                        <div className="mb-4 col-md-4">
                          <label className="form-label">Level</label>
                          <div className="cover-form">
                            <div>
                              <i
                                className="fa fa-user-o"
                                aria-hidden="true"
                              ></i>
                            </div>
                            <Dropdown
                              value={LessonFrom.values.Level}
                              onChange={(e) =>
                                LessonFrom.setFieldValue("Level", e.value.id)
                              }
                              options={selectedLevel}
                              optionLabel="Name"
                              placeholder="Level"
                              checkmark={true}
                              highlightOnSelect={false}
                            />{" "}
                          </div>
                          <div className="invalid-feedback">
                            {LessonFrom.errors.Level && LessonFrom.touched.Level
                              ? LessonFrom.errors.Level
                              : null}
                          </div>
                        </div>
                        <div className="mb-4 col-md-4">
                          <label className="form-label">Duration</label>
                          <div className="cover-form">
                            <div>
                              <i className="fa fa-money" aria-hidden="true"></i>
                            </div>
                            <input
                              type="number"
                              onChange={LessonFrom.handleChange}
                              value={LessonFrom.values.Duration}
                              name="Duration"
                              className={
                                "form-control" +
                                (LessonFrom.errors.Duration &&
                                LessonFrom.touched.Duration
                                  ? "is-invalid"
                                  : "")
                              }
                            />
                          </div>
                          <div className="invalid-feedback">
                            {LessonFrom.errors.Duration &&
                            LessonFrom.touched.Duration
                              ? LessonFrom.errors.Duration
                              : null}
                          </div>
                        </div>
                        <div className="mb-4 col-md-12">
                          <label className="form-label">Description</label>
                          <div className="cover-form">
                            <textarea
                              name="Description"
                              onChange={LessonFrom.handleChange}
                              value={LessonFrom.values.Description}
                              className={
                                "form-control h-auto" +
                                (LessonFrom.errors.Description &&
                                LessonFrom.touched.Description
                                  ? "is-invalid"
                                  : "")
                              }
                              rows="8"
                              cols="1"
                              placeholder="write some lines about this course.."
                            ></textarea>
                          </div>
                          <div className="invalid-feedback">
                            {LessonFrom.errors.Description &&
                            LessonFrom.touched.Description
                              ? LessonFrom.errors.Description
                              : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-4">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="card">
                      <div className="card-body">
                        <div
                          onClick={openFileVideoInput}
                          className="loadresumes"
                        >
                          <div className="inner">
                            {videoPath?.length == 0 ? (
                              <img src="/images/org-img/learn/add.png" />
                            ) : (
                              <LazyVideo src={videoPath} />
                            )}
                            <span>Upload Video</span>
                          </div>
                          <input
                            className="form-control"
                            name="VideoURL"
                            type="file"
                            onChange={handleVideoFileChange}
                            id="fileInput"
                            accept="video/*"
                            ref={fileInputVideoRef}
                            style={{ display: "none" }}
                          />
                          <div>
                            {LessonFrom.errors.VideoURL ? (
                              <p style={{ color: "red" }}>
                                {LessonFrom.errors.VideoURL}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="btns-grp">
                  <button type="submit" className="savebtn-click">
                    Save
                  </button>
                  <button type="submit" className="publish-click">
                    Publish
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="modal fade" id="give-rating">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <img src="/images/org-img/learn/rate.png" />
            <div className="modal-header p-0">
              <h5 className="modal-title m-auto">
                How would you rate your course experience?
              </h5>
            </div>
            <div className="modal-body text-center">
              <ul className="rate">
                <li>
                  <i className="fa fa-star"></i>
                </li>
                <li>
                  <i className="fa fa-star"></i>
                </li>
                <li>
                  <i className="fa fa-star"></i>
                </li>
                <li>
                  <i className="fa fa-star-o"></i>
                </li>
                <li>
                  <i className="fa fa-star-o"></i>
                </li>
              </ul>
              <form>
                <div className="form-group text-left">
                  <textarea
                    rows="6"
                    cols="1"
                    className="form-control"
                    placeholder="I would like to say that..."
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <i className="fa fa-angle-right" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AddVideoContent;
